if ($('footer#footer').length) {
  $('footer#footer').before($('.reviews'))

    $('#signature').append($('footer#footer .customSignature'));


    $(document).on('click', '.custom-footer>div h4', function () {
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });



    $('footer#footer .logoSocial ul.customSocial').append($('footer#footer .contact-box li span.instagram').closest('li'));


    $('footer#footer .contact .superContact').append($('footer#footer .contact-box li span.mail').closest('li').addClass('mail'));
    $('footer#footer .contact .superContact').append($('footer#footer .contact-box li span.tel').closest('li').addClass('tel'));

    $("footer#footer .footer-bottom").append($("footer#footer .paymentsList"));

    $('footer#footer').before($('footer#footer .instagramFeed'));

    $(".instagram-widget>a").each(function () {
        $(".instagramFeed .igFeed").append('<div class="igPost"><a href="' + $(this).attr("href") + '" target="_blank" style="background-image: url(' + $(this).find("img").attr("data-src") + ')"></a></div>')
    });



}